/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetByStateIdAndCountiesOptsApiModel } from '../../models/get-by-state-id-and-counties-opts-api-model';
import { PopulationLookupDataModelApiModel } from '../../models/population-lookup-data-model-api-model';

export interface GetPopulationByStateAndCounty$Params {
      body: GetByStateIdAndCountiesOptsApiModel
}

export function getPopulationByStateAndCounty(http: HttpClient, rootUrl: string, params: GetPopulationByStateAndCounty$Params, context?: HttpContext): Observable<StrictHttpResponse<PopulationLookupDataModelApiModel>> {
  const rb = new RequestBuilder(rootUrl, getPopulationByStateAndCounty.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PopulationLookupDataModelApiModel>;
    })
  );
}

getPopulationByStateAndCounty.PATH = '/v1/counties/population';
